module.exports = __webpack_public_path__ + "static/img/liucheng1.04df4577.png";